/**
 * "today 14:03" / "Aug 5" / "Aug 5, 2025" — compact timestamps for SmartSign
 * lists and cards.
 *
 * Shared by the templates list and step 1's starter cards so the same template
 * never reads as two different dates depending on where you look at it.
 * Month names beat digit soup at this size, and the year is only spent when it
 * is not the current one.
 */
export function updatedText(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';

  const now = new Date();
  if (d.toDateString() === now.toDateString()) {
    return `today ${d.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' })}`;
  }

  const sameYear = d.getFullYear() === now.getFullYear();
  return d.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    ...(sameYear ? {} : { year: 'numeric' }),
  });
}

/** Sortable stamp — invalid or absent dates sink to the bottom. */
export function stamp(iso) {
  const t = new Date(iso).getTime();
  return Number.isNaN(t) ? 0 : t;
}

/**
 * When a template last CHANGED — the later of the row's `updatedAt`, which every
 * autosave bumps, and `lastPublishedAt`. Both lists sort on this AND print it as
 * "Updated …", so a card's position always agrees with the date on it. Either
 * field can be absent (a never-published draft has no publish date), hence the
 * pick rather than a straight read.
 */
export function lastTouchedAt(template) {
  const dates = [template?.updatedAt, template?.lastPublishedAt].filter(Boolean);
  if (!dates.length) return null;
  return dates.reduce((latest, d) => (stamp(d) > stamp(latest) ? d : latest));
}
